<template>
  <div>
    <el-row :gutter="20">
      <el-col :xs="24" :md="12">
        <text-field
          v-model="formData.orders_id"
          :base="base"
          name="orders_id"
          :disabled="true"
          >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="12">
        <text-field
          v-model="formData.redeem_code"
          :base="base"
          name="redeem_code"
          :disabled="true"
          >
        </text-field>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="24" :md="8">
        <time-field
          v-model="formData.orders_created_at"
          :base="base"
          name="orders_created_at"
          readonly
          disabled
          >
        </time-field>
      </el-col>
      <el-col :xs="24" :md="8">
        <time-field
          v-model="formData.trade_time"
          :base="base"
          name="trade_time"
          readonly
          disabled
          >
        </time-field>
      </el-col>
      <el-col :xs="24" :md="8">
        <time-field
          v-model="formData.booking_time"
          :base="base"
          name="booking_time"
          :tzLocation="formData.tz_location"
          readonly
          disabled
          >
        </time-field>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="24" :md="12">
        <text-field
          v-model="formData.region_name"
          :base="base"
          name="region_name"
          :disabled="true"
          >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="12">
        <text-field
          v-model="formData.region_id"
          :base="base"
          name="region_id"
          :disabled="true"
          >
        </text-field>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="24" :md="12">
        <text-field
          v-model="formData.branch_name"
          :base="base"
          name="branch_name"
          :disabled="true"
          >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="12">
        <text-field
          v-model="formData.bid"
          :base="base"
          name="bid"
          :disabled="true"
          >
        </text-field>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="24" :md="12">
        <text-field
          v-model="formData.product_name"
          :base="base"
          name="product_name"
          :disabled="true"
          >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="12">
        <text-field
          v-model="formData.product_id"
          :base="base"
          name="product_id"
          :disabled="true"
          >
        </text-field>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="24" :md="8">
        <text-field
          v-model="formData.orders_amount"
          :base="base"
          name="orders_amount"
          :disabled="true"
          >
          <template slot="prepend-input">{{ formData.currency_code }}</template>
        </text-field>
      </el-col>
      <el-col :xs="24" :md="8">
        <text-field
          v-model="formData.bonus"
          :base="base"
          name="bonus"
          :disabled="true"
          >
          <template slot="prepend-input">f</template>
          <template slot="append-input">x {{ formData.fnc_rate }}</template>
        </text-field>
      </el-col>
      <el-col :xs="24" :md="8">
        <text-field
          v-model="formData.discount"
          :base="base"
          name="discount"
          :disabled="true"
          >
          <template slot="prepend-input">{{ formData.currency_code }}</template>
        </text-field>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="24" :md="12">
        <text-field
          v-model="formData.txn_amount"
          :base="base"
          :hasDesc="true"
          name="txn_amount"
          :disabled="true"
          >
          <template slot="prepend-input">{{ formData.currency_code }}</template>
        </text-field>
      </el-col>
      <el-col :xs="24" :md="12">
        <text-field
          v-model="formData.txn_pay_amount"
          :base="base"
          :hasDesc="true"
          name="txn_pay_amount"
          :disabled="true"
          >
          <template slot="prepend-input">{{ formData.txn_currency_code }}</template>
        </text-field>
      </el-col>
    </el-row>
  </div>
</template>

<script>

export default {
  name: 'orders-detail',
  props: {
    formData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      base: 'orders'
    }
  },
  computed: {
  },
  methods: {
  },
  watch: {
  }
}
</script>
